import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, LockIcon } from 'lucide-react';
const trust = ['Descarga inmediata', 'Garantía 07 días', 'Sin suscripciones'];
export function Hero() {
  return <section className="relative w-full overflow-hidden bg-cream" data-id="element-98" data-mp="9k0f38zo2hq6">
      <div className="leaf-watermark pointer-events-none absolute inset-0" aria-hidden="true" data-id="element-99" data-mp="4lqiqv27hb2z" />

      <div className="relative mx-auto grid max-w-7xl items-center gap-10 px-5 py-12 sm:px-6 lg:grid-cols-[58%_42%] lg:gap-12 lg:py-16" data-id="element-100" data-mp="4jvyliyrdmzy">
        {/* Mockup — first on mobile */}
        <motion.div initial={{
        opacity: 0,
        y: 18
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.4,
        ease: [0.23, 1, 0.32, 1],
        delay: 0.08
      }} className="order-1 flex flex-col items-center lg:order-2" data-id="element-101" data-mp="xb5w3rhcfg22">
          <p className="mb-3 text-sm font-semibold uppercase tracking-widest text-gold line-through decoration-2" data-id="element-102" data-mp="3d33f4zea6vla">
            Valor total: $238 USD
          </p>

          <div className="relative w-full max-w-md" data-id="element-103" data-mp="3j89618jhw3nf">
            <img src="https://cdn.magicpatterns.com/uploads/5oHx76ZLhegkVXSCRWfyYT/Portada_GENERAL.jpg" alt="El Método de Vaciado Biológico junto a sus tres bonos digitales" className="w-full rounded-2xl shadow-[0_24px_60px_rgba(26,60,46,0.28)]" width={1376} height={768} data-id="element-104" data-mp="3j6fw9kdl53b7" />
            <div className="absolute -bottom-4 right-2 rotate-[-3deg] rounded-xl bg-coral px-4 py-2 text-sm font-extrabold text-white shadow-lg sm:text-base" data-id="element-105" data-mp="3e7uw1kyc2jmr">
              HOY SOLO $9.99 USD
            </div>
          </div>

          <p className="mt-8 flex items-center gap-2 text-sm font-medium text-warmgray" data-id="element-106" data-mp="35au9ljutqvly">
            <LockIcon className="h-4 w-4 text-forest" aria-hidden="true" data-id="element-107" data-mp="2qhqtlgwvspxc" />
            Compra 100% segura
          </p>
        </motion.div>

        {/* Copy */}
        <motion.div initial={{
        opacity: 0,
        y: 18
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.4,
        ease: [0.23, 1, 0.32, 1]
      }} className="order-2 lg:order-1" data-id="element-108" data-mp="2hk83vz8alnf4">
          <span className="inline-flex rounded-full border border-gold px-3.5 py-1 text-[12px] font-semibold text-forest" data-id="element-109" data-mp="s44gvk8yvfgb">
            Protocolo Natural para Adultos 40+
          </span>

          <h1 className="mt-5 text-[34px] font-bold leading-[1.05] tracking-tight text-charcoal lg:text-[52px]" data-id="element-110" data-mp="ichy92uaue3j">
            Tu Cuerpo Lleva Años Siendo Saqueado.
          </h1>

          <h2 className="mt-4 text-[20px] font-semibold leading-snug text-forest lg:text-[26px]" data-id="element-111" data-mp="1azku1n7lcaq3">
            Recupera Tu Energía, Desinflámate y Elimina los Antojos en 21 Días — Sin Fármacos.
          </h2>

          <p className="mt-4 max-w-xl text-base font-normal leading-relaxed text-warmgray" data-id="element-112" data-mp="11150zep06rdy">
            El Método de Vaciado Biológico: el protocolo natural que miles de adultos de 40+ ya están
            aplicando.
          </p>

          <ul className="mt-6 flex flex-wrap gap-x-5 gap-y-2" data-id="element-113" data-mp="3lqm2xztl37vg">
            {trust.map(item => <li key={item} className="flex items-center gap-1.5 text-[13px] font-semibold text-forest" data-id="element-114" data-mp="3hq2852whggch">
                <CheckIcon className="h-4 w-4 text-gold" aria-hidden="true" data-id="element-115" data-mp="1x785vq9lpvv6" />
                {item}
              </li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
}